import { IconButton, Tooltip } from '@mui/material';
import { PinIcon, PinOutlineIcon } from '../../utils/icons';

const PIN_LIMIT_TOOLTIP = "You've reached the pin limit — remove a pin to add new ones.";

interface PinButtonProps {
  readonly displayName: string;
  readonly isPinned: boolean;
  readonly pinDisabled?: boolean;
  readonly onTogglePin: () => void;
}

export function PinButton({ displayName, isPinned, pinDisabled, onTogglePin }: PinButtonProps) {
  return (
    <Tooltip title={!isPinned && pinDisabled ? PIN_LIMIT_TOOLTIP : ''} placement="top">
      <span>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onTogglePin();
          }}
          disabled={!isPinned && !!pinDisabled}
          aria-label={isPinned ? `Unpin ${displayName}` : `Pin ${displayName} to top`}
          sx={{
            borderRadius: 1,
            bgcolor: isPinned ? 'primary.main' : 'secondary.light',
            color: isPinned ? 'primary.contrastText' : 'primary.main',
            '&:hover': {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
            },
          }}
        >
          {isPinned ? <PinIcon fontSize="small" /> : <PinOutlineIcon fontSize="small" />}
        </IconButton>
      </span>
    </Tooltip>
  );
}
